/* =========================================================
   VELOURA — shared behaviours v2
   Mobile-Nav · Scroll-Reveal · Hero-Sonnenuhr (Echtzeit) · Trilogie-Lichtsystem
   ========================================================= */
(function(){
  "use strict";
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var toggle = document.querySelector('.nav-toggle'), nav = document.querySelector('.main-nav');
  if(toggle && nav){
    function closeNav(){
      nav.classList.remove('open');
      toggle.setAttribute('aria-expanded', 'false');
    }
    toggle.addEventListener('click', function(e){
      e.stopPropagation();
      var open = nav.classList.toggle('open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    // Schließen bei Klick irgendwo außerhalb der Navigation
    document.addEventListener('click', function(e){
      if(!nav.classList.contains('open')) return;
      if(nav.contains(e.target) || toggle.contains(e.target)) return;
      closeNav();
    });
    // Schließen bei Klick auf einen Menüpunkt
    nav.addEventListener('click', function(e){
      if(e.target.closest('a')) closeNav();
    });
    // Schließen mit Escape
    document.addEventListener('keydown', function(e){ if(e.key === 'Escape') closeNav(); });
  }

  /* ---- Warenkorb-Schublade (links, AJAX) ---- */
  var drawer = document.getElementById('CartDrawer');
  if(drawer){
    var cartItems  = document.getElementById('CartItems');
    var cartTotal  = document.getElementById('CartTotal');
    var checkout   = document.getElementById('CartCheckout');
    var discForm   = document.getElementById('CartDiscount');
    var discNote   = document.getElementById('CartDiscountNote');
        var discActive = document.getElementById('CartDiscountActive');
            var cartSummary= document.getElementById('CartSummary');
    var cartOrig   = document.getElementById('CartOriginal');
    var cartSaved  = document.getElementById('CartSavings');
    var cartCounts = document.querySelectorAll('[data-cart-count]');
    var cartCross  = document.getElementById('CartCross');

    function updateCross(cart){
      if(!cartCross) return;
      var items = cart.items || [];
      // Verstecken, wenn leer oder wenn das Trilogie-Set bereits im Warenkorb liegt
      var hasTrilogy = items.some(function(it){
        var h = (it.handle||'') + ' ' + (it.product_type||'');
        return /trilog/i.test(h);
      });
      cartCross.hidden = (items.length === 0 || hasTrilogy);
    }

    function euro(c){ return (c/100).toLocaleString('de-DE',{minimumFractionDigits:2,maximumFractionDigits:2}) + '\u00A0€'; }
    function sized(url,w){ if(!url) return ''; return url + (url.indexOf('?')>-1?'&':'?') + 'width=' + w; }

    function openDrawer(){ drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden','false'); document.body.style.overflow='hidden'; }
    function closeDrawer(){ drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden','true'); document.body.style.overflow=''; }

    function render(cart){
      cartCounts.forEach(function(n){ n.textContent = cart.item_count; });
      if(cartTotal) cartTotal.textContent = euro(cart.total_price);
          var saved = cart.total_discount || 0;
      if(discActive) discActive.hidden = !(saved > 0 || (cart.cart_level_discount_applications && cart.cart_level_discount_applications.length));
      if(cartSummary){
        if(saved > 0){
          cartSummary.hidden = false;
          if(cartOrig)  cartOrig.textContent  = euro(cart.total_price + saved);
          if(cartSaved) cartSaved.textContent = '\u2212' + euro(saved);
        } else {
          cartSummary.hidden = true;
        }
      }
      if(checkout) checkout.setAttribute('aria-disabled', cart.item_count ? 'false' : 'true');
      if(!cart.items || !cart.items.length){
        cartItems.innerHTML = '<p class="cart-drawer__empty muted">Ihr Warenkorb ist noch leer.</p>';
        return;
      }
      var html = '';
      cart.items.forEach(function(it){
        var img = it.image
          ? '<img class="cart-line__img" src="'+sized(it.image,200)+'" alt="">'
          : '<span class="cart-line__img cart-line__img--empty"></span>';
        html += '<div class="cart-line" data-key="'+it.key+'">'
          + img
          + '<div class="cart-line__info">'
          +   '<div class="cart-line__title">'+it.product_title+'</div>'
          +   '<div class="cart-line__price">'+euro(it.final_price)+'</div>'
          +   '<div class="qty" data-key="'+it.key+'">'
          +     '<button type="button" class="qty__btn" data-qty-dec aria-label="Weniger">\u2212</button>'
          +     '<span class="qty__val">'+it.quantity+'</span>'
          +     '<button type="button" class="qty__btn" data-qty-inc aria-label="Mehr">+</button>'
          +   '</div>'
          + '</div>'
          + '<button type="button" class="cart-line__remove" data-remove aria-label="Entfernen"><i class="ti ti-trash" aria-hidden="true"></i></button>'
          + '</div>';
      });
      cartItems.innerHTML = html;
    }

    function fetchCart(open){
      fetch('/cart.js',{headers:{'X-Requested-With':'XMLHttpRequest'}})
        .then(function(r){ return r.json(); })
        .then(function(c){ render(c); if(open) openDrawer(); });
    }
    function changeQty(key,qty){
      fetch('/cart/change.js',{method:'POST',
        headers:{'Content-Type':'application/json','X-Requested-With':'XMLHttpRequest'},
        body:JSON.stringify({ id:key, quantity:qty })})
        .then(function(r){ return r.json(); }).then(render);
    }

    document.querySelectorAll('[data-cart-open]').forEach(function(b){
      b.addEventListener('click', function(e){ e.preventDefault(); fetchCart(true); });
    });
    drawer.addEventListener('click', function(e){ if(e.target.closest('[data-cart-close]')) closeDrawer(); });
    document.addEventListener('keydown', function(e){ if(e.key==='Escape') closeDrawer(); });

    cartItems.addEventListener('click', function(e){
      var line = e.target.closest('.cart-line'); if(!line) return;
      var key = line.getAttribute('data-key');
      var val = line.querySelector('.qty__val');
      var q = val ? parseInt(val.textContent,10) : 1;
      if(e.target.closest('[data-remove]')) changeQty(key,0);
      else if(e.target.closest('[data-qty-inc]')) changeQty(key,q+1);
      else if(e.target.closest('[data-qty-dec]')) changeQty(key,Math.max(0,q-1));
    });

    document.addEventListener('submit', function(e){
      var f = e.target;
      if(!f || !f.action || f.action.indexOf('/cart/add') < 0) return;
      e.preventDefault();
      var btn = f.querySelector('[name="add"]');
      if(btn){ btn.disabled = true; }
      fetch('/cart/add.js',{method:'POST',body:new FormData(f),headers:{'X-Requested-With':'XMLHttpRequest'}})
        .then(function(r){ return r.json(); })
        .then(function(){ if(btn){ btn.disabled=false; } fetchCart(true); })
        .catch(function(){ if(btn){ btn.disabled=false; } });
    });

    if(discForm){
      discForm.addEventListener('submit', function(e){
        e.preventDefault();
        var code = (discForm.querySelector('input').value || '').trim();
        if(!code) return;
        fetch('/discount/'+encodeURIComponent(code),{headers:{'X-Requested-With':'XMLHttpRequest'}})
          .then(function(){
            if(discNote){ discNote.hidden=false; discNote.textContent='Code „'+code+'“ übernommen – wird an der Kasse verrechnet.'; }
          });
      });
    }
  }

  /* ---- Produkt-Galerie: Thumbnail-Klick, Pfeile & Swipe ---- */
  var pdpThumbs = Array.prototype.slice.call(document.querySelectorAll('.pdp-thumb'));
  var pdpMain = document.getElementById('pdpMainImg');
  if(pdpThumbs.length && pdpMain){
    var gIndex = 0;
    pdpThumbs.forEach(function(t,i){ if(t.classList.contains('is-active')) gIndex = i; });

    function showIndex(i){
      var n = pdpThumbs.length;
      gIndex = (i % n + n) % n;
      var t = pdpThumbs[gIndex];
      var full = t.getAttribute('data-full');
      if(full){ pdpMain.src = full; }
      pdpThumbs.forEach(function(x){ x.classList.remove('is-active'); });
      t.classList.add('is-active');
      t.scrollIntoView({block:'nearest', inline:'center', behavior:'smooth'});
    }

    pdpThumbs.forEach(function(t,i){
      t.addEventListener('click', function(){ showIndex(i); });
    });

    var gPrev = document.querySelector('[data-gallery-prev]');
    var gNext = document.querySelector('[data-gallery-next]');
    if(gPrev) gPrev.addEventListener('click', function(){ showIndex(gIndex - 1); });
    if(gNext) gNext.addEventListener('click', function(){ showIndex(gIndex + 1); });

    var gStage = document.querySelector('[data-gallery] .pdp-media');
    if(gStage){
      var tx0 = null;
      gStage.addEventListener('touchstart', function(e){ tx0 = e.changedTouches[0].clientX; }, {passive:true});
      gStage.addEventListener('touchend', function(e){
        if(tx0 === null) return;
        var dx = e.changedTouches[0].clientX - tx0;
        if(Math.abs(dx) > 40){ showIndex(dx < 0 ? gIndex + 1 : gIndex - 1); }
        tx0 = null;
      }, {passive:true});
    }
    document.addEventListener('keydown', function(e){
      if(e.key === 'ArrowLeft') showIndex(gIndex - 1);
      else if(e.key === 'ArrowRight') showIndex(gIndex + 1);
    });
  }

  /* ---- Mobiler fixierter Kauf-Balken ---- */
  var stickyBar = document.querySelector('[data-pdp-stickybar]');
  var realAdd = document.querySelector('.pdp-buy button[name="add"]');
  if(stickyBar && realAdd){
    var stickyAddBtn = stickyBar.querySelector('[data-pdp-add]');
    if(stickyAddBtn){
      stickyAddBtn.addEventListener('click', function(){ realAdd.click(); });
    }
    var barIO = new IntersectionObserver(function(es){
      es.forEach(function(e){
        // Balken zeigen, sobald der echte Button aus dem Blick scrollt
        if(e.isIntersecting){ stickyBar.classList.remove('is-visible'); }
        else if(e.boundingClientRect.top < 0){ stickyBar.classList.add('is-visible'); }
        else { stickyBar.classList.remove('is-visible'); }
      });
    }, {threshold:0});
    barIO.observe(realAdd);
  }

  var revealables = document.querySelectorAll('[data-reveal], .note');
  if(revealables.length){
    var io = new IntersectionObserver(function(es){
      es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); } });
    },{threshold:0.2, rootMargin:'0px 0px -8% 0px'});
    revealables.forEach(function(n){ io.observe(n); });
  }

  function dayFraction(){
    var d = new Date(), hd = d.getHours() + d.getMinutes()/60 + d.getSeconds()/3600;
    return { f: hd/24, d:d };   // ganze 24 Stunden über den Bogen → Sonne folgt der echten Uhrzeit
  }
  function greeting(d){
    var h=d.getHours(), duft = h<11?'Soléa':(h<18?'Luzia':'Libration');
    return 'Es ist '+('0'+h).slice(-2)+':'+('0'+d.getMinutes()).slice(-2)+' — die Stunde von '+duft;
  }

  var dial = document.getElementById('hero-dial');
  if(dial){
    var path = dial.querySelector('#dial-arc'), sun = dial.querySelector('#dial-sun');
    var flacon = document.querySelector('.hero__flacon .flacon');
    var now = document.getElementById('hero-now');
    var t = dayFraction();
    if(now) now.textContent = greeting(t.d);
    // Zeit-Labels (06:00/13:00/21:00) exakt auf ihre echte Position im 24h-Bogen setzen
     if(path){
      var arcLen = path.getTotalLength();
      Array.prototype.forEach.call(dial.querySelectorAll('.tlab'), function(lab){
        var lh = parseFloat(lab.getAttribute('data-hour'));
        if(isNaN(lh)) return;
        var frac = lh <= 6 ? 0 : (lh >= 21 ? 1 : 0.5);   // 06:00 Bogen-Anfang links · 13:00 Mitte · 21:00 Bogen-Ende rechts
        var lp = path.getPointAtLength(frac*arcLen);
        var nx = lp.x - 340, ny = lp.y - 190;
        var len = Math.sqrt(nx*nx + ny*ny) || 1;
        lab.setAttribute('x', (lp.x + (nx/len)*28).toFixed(1));
        lab.setAttribute('y', (lp.y + (ny/len)*28 + 4).toFixed(1));
      });
    }
    function place(f){
      if(path && sun){
        var L = path.getTotalLength(), p = path.getPointAtLength(f*L);
        sun.setAttribute('cx', p.x); sun.setAttribute('cy', p.y);
      }
      if(flacon){
        var sx = (0.5 - f)*2*34;
        var noon = 1 - Math.abs(f-0.5)*2;
        flacon.style.setProperty('--shadow-x', sx.toFixed(0)+'px');
        flacon.style.setProperty('--shadow-alpha', (0.14 + (1-noon)*0.2).toFixed(2));
      }
    }
    if(reduce){ place(t.f); }
    else{
      place(0);
      var start=null, dur=1600;
      requestAnimationFrame(function step(ts){
        if(start===null) start=ts;
        var k=Math.min(1,(ts-start)/dur), e=1-Math.pow(1-k,3);
        place(t.f*e);
        if(k<1) requestAnimationFrame(step);
      });
    }
    setInterval(function(){ var n=dayFraction(); if(now) now.textContent=greeting(n.d); place(n.f); }, 60000);
  }

  var journey = document.querySelector('.journey');
  if(!journey) return;

  var stops=[[0,[239,231,214]],[.16,[240,228,200]],[.34,[236,199,127]],[.5,[224,169,75]],[.68,[200,118,63]],[.82,[162,75,44]],[.93,[80,42,50]],[1,[46,27,36]]];
  function lerp(a,b,t){ return a+(b-a)*t; }
  function mix(c1,c2,t){ return [Math.round(lerp(c1[0],c2[0],t)),Math.round(lerp(c1[1],c2[1],t)),Math.round(lerp(c1[2],c2[2],t))]; }
  function bgAt(p){ for(var i=0;i<stops.length-1;i++){ if(p<=stops[i+1][0]){ var t=(p-stops[i][0])/(stops[i+1][0]-stops[i][0]); return mix(stops[i][1],stops[i+1][1],t);} } return stops[stops.length-1][1]; }
  function lum(c){ return (0.299*c[0]+0.587*c[1]+0.114*c[2])/255; }

  var sky=document.getElementById('sky'), sunEl=document.getElementById('sun'), grain=document.getElementById('grain'),
      header=document.querySelector('.site-header'), root=document.documentElement.style;

  function apply(p){
    var c=bgAt(p), rgb='rgb('+c[0]+','+c[1]+','+c[2]+')', dark=lum(c)<0.52;
    if(sky) sky.style.backgroundColor=rgb;
    root.setProperty('--ink', dark ? '#F1E9D8' : '#221A13');
    root.setProperty('--ink-soft', dark ? 'rgba(241,233,216,0.66)' : '#6E6353');
    root.setProperty('--line-strong', dark ? 'rgba(241,233,216,0.3)' : 'rgba(34,26,19,0.34)');
    var sx=Math.cos(p*Math.PI)*42, noon=1-Math.abs(p-0.5)*2;
    root.setProperty('--shadow-x', sx.toFixed(0)+'px');
    root.setProperty('--shadow-alpha', (0.16+(1-noon)*0.2).toFixed(2));
    root.setProperty('--copper', dark ? '#E7A277' : '#9A7B3F');
    if(sunEl) sunEl.style.top=(16+p*68)+'vh';
    if(grain) grain.style.opacity=Math.max(0,(p-0.6))*0.9;
    if(header) header.classList.toggle('on-dark', dark);
  }
  var ticking=false;
  function scrollProgress(){
    var de=document.documentElement, bd=document.body;
    var sy=window.pageYOffset||de.scrollTop||bd.scrollTop||0;
    var sh=Math.max(de.scrollHeight, bd.scrollHeight, de.offsetHeight);
    var max=sh-window.innerHeight;
    return max>0?Math.min(1,Math.max(0,sy/max)):0;
  }
  function onScroll(){
    var p=scrollProgress();
    if(!ticking){ ticking=true; requestAnimationFrame(function(){ apply(reduce?Math.round(p*7)/7:p); ticking=false; }); }
  }
  window.addEventListener('scroll',onScroll,{passive:true});
  document.addEventListener('scroll',onScroll,{passive:true});
  window.addEventListener('resize',onScroll);
  window.addEventListener('touchmove',onScroll,{passive:true});

  var pill=document.getElementById('clockPill');
  if(pill){ var g=dayFraction(); pill.textContent=greeting(g.d)+'.'; setTimeout(function(){ pill.style.opacity='1'; },900); }

  onScroll();
})();
